/**
 * @ngdoc component
 * @name kpStringCollapser
 * @module portaro.components
 *
 * @param {characters=} how many characters will be showed at collapsed state
 *
 * @description
 * Component for show-more/show-less functionality
 *
 * @example
 * ```html
 *  <kp-string-collapser value="stringVariable" characters-limit="60" />
 * ```
 */
export class StringCollapserController {

    private collapsed: boolean;
    private value: string;
    private charactersLimit: number;

    /*@ngInject*/
    constructor() {
        this.collapsed = true;
    }

    public toggle() {
        this.collapsed = !this.collapsed;
    }

    public isCollapsed() {
        return this.collapsed;
    }

    public isCollapsible() {
        return this.value.length > this.charactersLimit;
    }
}
